import { Card, Col, Flex, Row, Typography } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { MonoValue } from 'src/components'

type Props = {
  baseURL: string
}

export const OidcReferenceCard = ({ baseURL }: Props) => {
  const { t } = useTranslation()

  const items = useMemo(() => {
    if (!baseURL) return []
    return [
      {
        key: 'issuer',
        label: 'Issuer',
        value: `${baseURL}/authorization/v2/oidc`
      },
      {
        key: 'discovery',
        label: 'Discovery URL',
        value: `${baseURL}/authorization/v2/oidc/.well-known/openid-configuration`
      },
      {
        key: 'authorize',
        label: 'Authorize URL',
        value: `${baseURL}/authorization/v2/oidc/authorize/`
      },
      {
        key: 'token',
        label: 'Token URL',
        value: `${baseURL}/authorization/v2/oidc/token/`
      },
      {
        key: 'userinfo',
        label: 'UserInfo URL',
        value: `${baseURL}/authorization/v2/oidc/userinfo/`
      },
      {
        key: 'jwks',
        label: 'JWKS URL',
        value: `${baseURL}/authorization/v2/oidc/.well-known/jwks.json`
      }
    ]
  }, [baseURL])

  if (!items.length) return null

  return (
    <Card
      variant="outlined"
      size="small"
      title={t('oidc.reference', 'OIDC reference')}
    >
      <Row gutter={[14, 12]}>
        {items.map((item) => (
          <Col key={item.key} xs={24} md={12}>
            <Flex vertical gap={4}>
              <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                {item.label.toUpperCase()}
              </Typography.Text>
              <MonoValue ellipsis>{item.value}</MonoValue>
            </Flex>
          </Col>
        ))}
      </Row>
    </Card>
  )
}
